/**
 * Marka ayarları tek yerden. İsim/domain değişirse sadece burası değişir.
 */
export const site = {
  name: "AraçKutusu",
  shortName: "AraçKutusu",
  domain: "arackutusu.com",
  url: "https://arackutusu.com",
  // TODO: gerçek adresle değiştir
  email: "iletisim@arackutusu.com",
  tagline: "Dosyalarınız bilgisayarınızdan çıkmadan.",
  description:
    "PDF birleştirme, küçültme ve dönüştürme, görsel sıkıştırma, video düzenleme ve kırpma, CV oluşturma, QR kod ve daha fazlası. Tamamı tarayıcınızda çalışır — dosyalarınız hiçbir sunucuya yüklenmez.",
  locale: "tr_TR",
  lang: "tr",
  // Google Search Console doğrulama kodu (Search Console → Mülk ekle → HTML etiketi
  // → content="..." kısmındaki kodu buraya yapıştır). Boşken doğrulama etiketi eklenmez.
  googleVerification: "",
  // Yandex Webmaster doğrulama kodu (webmaster.yandex.com.tr → Site ekle →
  // Meta etiketi → content="..." kısmındaki kod). Boşken etiket eklenmez.
  yandexVerification: "",
  // IndexNow anahtarı — Yandex + Bing'e yeni/güncellenen sayfaları anında bildirir.
  // Aynı değer public/<anahtar>.txt dosyasında da durmalı (doğrulama için).
  indexNowKey: "5749f5eaa4eaf2bd1c424c97627663c3",
  // Google AdSense yayıncı kimliği (ca-pub-...). Boşken reklam scripti eklenmez.
  adsensePubId: "ca-pub-7852166166747122",
  // Reklam birimi kimlikleri (AdSense onayı sonrası: Reklamlar → Reklam birimleri →
  // oluştur → data-ad-slot numarasını buraya yaz). Boşken canlıda reklam gösterilmez.
  adSlots: {
    icerik: "", // araç sayfaları / bölümler arası
    blog: "", // blog yazısı içi
    yan: "", // kenar (sidebar) reklamı — kategori sayfaları
  },
} as const;
